import { trackEvent } from "@/utils/analytics";

import { conversionTrackingConfig } from "../config";
import type { LeadConversionAdapter } from "../contracts";
import { createDeliveryResult } from "../contracts";

export const ga4LeadAdapter: LeadConversionAdapter = {
  id: "ga4",
  async trackLead(event) {
    if (!conversionTrackingConfig.ga4MeasurementId) {
      return createDeliveryResult({
        provider: this.id,
        channel: "browser",
        eventName: "generate_lead",
        status: "skipped",
        eventId: event.conversionEventId,
        reason: "measurement_id_missing",
      });
    }

    if (event.consent.analytics === "denied") {
      return createDeliveryResult({
        provider: this.id,
        channel: "browser",
        eventName: "generate_lead",
        status: "skipped",
        eventId: event.conversionEventId,
        reason: "analytics_consent_denied",
      });
    }

    const path = event.entryPoint === "home_hero" ? "/" : "/request/";
    trackEvent("generate_lead", path, {
      inquiry_type: "request",
      conversion_event_id: event.conversionEventId,
      ...event.attributes,
    });

    return createDeliveryResult({
      provider: this.id,
      channel: "browser",
      eventName: "generate_lead",
      status: "sent",
      eventId: event.conversionEventId,
    });
  },
};
